import gql from 'graphql-tag';
import { Inject, Injectable } from '@nestjs/common';
import { client } from './apollo-client';
import { Store } from './store';
import { CONNECT_URL } from './environment';
import * as authUtils from './auth0-pcke';

export const GET_TICKET_STATUSES = gql`
  {
    currentUser {
      organizations {
        id
      }
    }
    ticketStatuses {
      clientSideId
      updatedSinceLastViewed
    }
  }
`;

function dateRange(from: number, to: number) {
  const MILLIS_IN_A_DAY = 1000 * 60 * 60 * 24;
  return (
    new Date().getTime() +
    MILLIS_IN_A_DAY * from +
    MILLIS_IN_A_DAY * (to - from) * Math.random()
  );
}

@Injectable()
export class NotificationService {
  status: 'clean' | 'notified' = 'clean';
  initialized = false;

  constructor(
    @Inject('store') private readonly store: Store,
    @Inject('showNotification') private readonly showNotification: Function
  ) {}

  setUpNotifications() {
    this.setUpTicketsNotification();
  }

  private showConnectReminder() {
    const t = +this.store.get('next_vscode_reminder_time', null);
    if (!t) {
      // we don't want to show the notification right away
      // we wait from 5 to 8 days before reminding the user about connect
      // do it randomly, such that if they use multiple machine,
      // all the reminders do appear at the same time
      this.store.set('next_vscode_reminder_time', dateRange(5, 8));
    } else if (t < new Date().getTime()) {
      this.showNotification(
        'Chat with Nrwl Experts to get help with Angular, React, Nest, Nx questions.',
        [
          {
            label: 'Real Time Help',
            action: { url: `${CONNECT_URL}/app/dashboard?chat=true` }
          }
        ]
      );
      // next reminder will be shown from 20 to 30 days in the future
      this.store.set('next_vscode_reminder_time', dateRange(20, 30));
    }
  }

  private setUpTicketsNotification() {
    if (authUtils.getAccessTokenFromStore()) {
      client()
        .watchQuery({
          query: GET_TICKET_STATUSES,
          pollInterval: 10000,
          fetchPolicy: 'network-only'
        })
        .subscribe(
          (r: any) => {
            if (
              r.data &&
              r.data.currentUser &&
              r.data.currentUser.organizations &&
              r.data.currentUser.organizations.length > 0
            ) {
              this.showConnectReminder();
            }
            if (r.data && r.data.ticketStatuses) {
              const statuses = r.data.ticketStatuses;
              const updatedTicket = statuses.find(
                (s: any) => s.updatedSinceLastViewed
              );
              if (this.status === 'clean') {
                if (updatedTicket) {
                  this.showNotification('Connect: Tickets Updated', [
                    {
                      label: 'Check updated tickets',
                      action: {
                        extension: 'extension.angularConsole',
                        route: 'Connect'
                      }
                    }
                  ]);
                  this.status = 'notified';
                }
              } else {
                if (!updatedTicket) {
                  this.status = 'clean';
                }
              }
            }
          },
          () => {}
        );
    }
  }
}
